import useLanguage from "@/hooks/useLanguage";
import React from "react";
import {lightTips} from "@/pages/person-center";

const useErrorMap = () =>{
  const {t} = useLanguage();
  const errCodeMap = {
    16004004: t('product_h5.modal.error_not_creator'),
    16004005: <>
      {t('error_map.already_joined_program')} {lightTips(t('error_map.im_already_eligible'))} {t('error_map.button_to_update_data')}
      {lightTips(t('error_map.cancel_your_contact'))} {t('error_map.and_join_us_again')}
    </>,
    16004006: <>
      {t('error_map.we_sent_you')} {lightTips(t('error_map.anystarr_or_partner_link'))} {t('error_map.and_more_details')}
      {lightTips(t('error_map.accept_request'))}{t('error_map.exclamation')}
    </>,
    16004014: t('product_h5.modal.error_has_shop'),
    16007119: <>
      {t('error_map.sorry_only_us_market')}
    </>
  };

  return {
    errCodeMap
  };
};

export default useErrorMap;
